import banner404 from '@treneo/assets/images/banner-404.svg';
import { useAppTranslations } from '@treneo/shared/i18n';
import { Colors } from '@treneo/shared/themes';

import { SingleLine } from '../components/single-line';
import { Typography } from '../components/typography';
import { Link } from '../link';
import { styled } from '../styled';

import {
  ButtonLink,
  LeftColumn,
  StyledCloseButton,
  StyledContainer,
  StyledMuiLink,
  Wrapper
} from './not-found-page.styles';

const StyledImg = styled('img')`
  max-height: 450px;
`;

export const NotFoundPage = () => {
  const { t } = useAppTranslations();

  const handleBackClick = () => window.history.back();

  return (
    <StyledContainer>
      <Wrapper>
        <LeftColumn>
          <Typography>{t('notFoundPage.title')}</Typography>
          <Typography fontSize='164px' fontWeight={700} color={Colors.black}>
            404
          </Typography>
          <Typography>{t('notFoundPage.firstLine')}</Typography>
          <SingleLine>
            <ButtonLink onClick={handleBackClick}>{t('notFoundPage.backButton')}</ButtonLink>
            <Typography>{t('notFoundPage.secondLine')}</Typography>
            <Link to='/' label={t('notFoundPage.mainPage')} />
          </SingleLine>
          <SingleLine>
            <Typography>{t('notFoundPage.thirdLine')}</Typography>
            <StyledMuiLink href='mailto:kontakt@treneo.pl'>kontakt@treneo.pl</StyledMuiLink>
          </SingleLine>
        </LeftColumn>
        <StyledImg src={banner404} alt='banner 404'></StyledImg>
        <StyledCloseButton onClose={handleBackClick} />
      </Wrapper>
    </StyledContainer>
  );
};
